<template>
  <v-dialog v-model="dialog" max-width="350">
    <v-card class="shadow">
      <v-card-title class="text-h6 font-weight-regular">
        Filter
      </v-card-title>

      <v-card-text>
        <v-form ref="form" @submit.prevent="do_filter" lazy-validation class="d-flex flex-column" style="gap:1rem">
          <v-menu v-model="date_from_menu" :close-on-content-click="false" transition="scale-transition" offset-y
            min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="date_from" :rules="[rules.required]" label="Date From" hide-details="auto" readonly
                outlined dense v-bind="attrs" v-on="on" @keyup="date_from_menu = true" @keydown="date_from_menu = false"
                clearable></v-text-field>
            </template>
            <v-date-picker v-model="date_from" @input="date_from_menu = false"></v-date-picker>
          </v-menu>

          <v-menu v-model="date_to_menu" :close-on-content-click="false" transition="scale-transition" offset-y
            min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="date_to" label="Date To (Optional)" hide-details="auto" readonly outlined dense
                v-bind="attrs" v-on="on" @keyup="date_to_menu = true" @keydown="date_to_menu = false"
                clearable></v-text-field>
            </template>
            <v-date-picker v-model="date_to" @input="date_to_menu = false" :min="date_from"></v-date-picker>
          </v-menu>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <div class="d-flex justify-end" style="width: 100%; gap:.30rem">
          <v-btn depressed class="px-2 grey lighten-5" @click="close_dialog">
            Cancel
          </v-btn>

          <v-btn depressed class="px-2" color="primary" @click="do_filter">
            Filter
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import form_rules from '@/helpers/formRules'

export default {
  props: {
    data: {
      type: Object
    }
  },

  data: () => ({
    rules: form_rules,
    mobile_number: '',
    date_from: null,
    date_from_menu: false,
    date_to: null,
    date_to_menu: false,
  }),

  computed: {
    dialog: {
      get: function () {
        return true
      },
      set: function () {
        this.close_dialog()
      }
    },
  },

  mounted() {
    this.date_from = this.data.date_from
    this.date_to = this.data.date_to
  },

  methods: {
    do_filter() {
      if (this.$refs.form.validate()) {
        this.$emit("set_close_filter_dialog", {
          'type': true,
          'date_from': this.date_from,
          'date_to': (this.date_to) ?? this.date_from
        })
      }
    },

    remove_leading_zero() {
      this.mobile_number = this.mobile_number.replace(/^0+/, "");
    },

    close_dialog() {
      this.$emit("set_close_filter_dialog", { type: false })
    }
  },

  watch: {
    date_from(val) {
      if (new Date(val) > new Date(this.date_to)) {
        this.date_to = val
      }
    }
  }
}
</script>